import _defineProperty from "/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

/* eslint-disable import/prefer-default-export */
import classNames from 'classnames';
import { isPresetColor } from '../_util/colors';
export function parseColor(prefixCls, color) {
  var isInternalColor = isPresetColor(color);
  var className = classNames(_defineProperty({}, "".concat(prefixCls, "-").concat(color), color && isInternalColor));
  var overlayStyle = {};
  var arrowStyle = {};

  if (color && !isInternalColor) {
    overlayStyle.background = color; // @ts-ignore

    arrowStyle['--antd-arrow-background-color'] = color;
  }

  return {
    className: className,
    overlayStyle: overlayStyle,
    arrowStyle: arrowStyle
  };
}